import DOMPurify from 'isomorphic-dompurify'
import type { ComponentPropsWithoutRef, ElementType } from 'react'
import { twMerge } from 'tailwind-merge'

type SafeHtmlTextTag = 'div' | 'li' | 'p' | 'span'

type SafeHtmlTextProps<T extends SafeHtmlTextTag = 'span'> = {
  as?: T
  html: string
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'dangerouslySetInnerHTML'>

function SafeHtmlText<T extends SafeHtmlTextTag = 'span'>({
  as,
  className,
  html,
  ...rest
}: SafeHtmlTextProps<T>) {
  const Component = (as ?? 'span') as ElementType

  return (
    <Component
      {...rest}
      className={twMerge('link-container [&_a]:no-underline', className)}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
  )
}

export { SafeHtmlText }
export type { SafeHtmlTextProps, SafeHtmlTextTag }
